export const MinusIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Minus",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
};
